/* styled-components & other non-external style-related exports (like, say, a `headerHeight` var) go here */
import { font, colors, spacing, breakpoints, gradient } from '@chegg-ui/theme';
import { IconButton } from '@chegg-ui/button';
import { Link } from '@chegg-ui/link';
import styled, { css } from 'styled-components';
import { NotificationTypes } from './types';
export var NotificationContainer = styled.section.withConfig({
  componentId: "sc-16bjbgs-0"
})(["display:flex;flex:initial;width:", ";position:relative;align-items:center;justify-content:space-between;", " font-family:", ";min-height:4.5rem;border-radius:", ";box-shadow:", ";"], function (_ref) {
  var type = _ref.type,
      customTheme = _ref.customTheme,
      bannerStyle = _ref.bannerStyle;
  return customTheme[type][bannerStyle].width;
}, function (_ref2) {
  var type = _ref2.type,
      customTheme = _ref2.customTheme,
      src = _ref2.src;
  return type === NotificationTypes.Moment && src ? css(["background:url(", ");background-size:cover;background-repeat:no-repeat;background-position:center;"], src) : "background: ".concat(customTheme[type].backgroundColor, ";");
}, font.family["default"], function (_ref3) {
  var type = _ref3.type,
      customTheme = _ref3.customTheme,
      bannerStyle = _ref3.bannerStyle;
  return customTheme[type][bannerStyle].borderRadius;
}, function (_ref4) {
  var type = _ref4.type,
      customTheme = _ref4.customTheme,
      bannerStyle = _ref4.bannerStyle;
  return customTheme[type][bannerStyle].boxShadow;
});
export var SmallNotificationContainer = styled(NotificationContainer).withConfig({
  componentId: "sc-16bjbgs-1"
})(["min-height:2.75rem;"]);
export var NotifContent = styled.div.withConfig({
  componentId: "sc-16bjbgs-2"
})(["padding:", "rem;", " margin:0 auto;position:relative;width:100%;display:flex;", ""], 8 / 16, function (_ref5) {
  var hasCloseButton = _ref5.hasCloseButton,
      customTheme = _ref5.customTheme;
  return customTheme.showHorizonIcons ? "padding-right: calc(".concat(10 / 16, "rem + ").concat(spacing.px24, ");") : hasCloseButton ? "padding-right: calc(".concat(10 / 16, "rem + ").concat(spacing.px24, ");") : '';
}, function (_ref6) {
  var fluid = _ref6.fluid;
  return fluid ? '' : css(["@media only screen and (max-width:", "){max-width:956px;}@media only screen and (max-width:", "){max-width:706px;}"], breakpoints.xl.max, breakpoints.lg.max);
});
export var LargeNotifContent = styled(NotifContent).withConfig({
  componentId: "sc-16bjbgs-3"
})(["padding:", ";padding-right:calc(", " + ", ");"], spacing.px16, spacing.px16, spacing.px24);
export var NotifMessage = styled.div.withConfig({
  componentId: "sc-16bjbgs-4"
})(["display:inline-block;color:", ";"], function (_ref7) {
  var customTheme = _ref7.customTheme,
      type = _ref7.type;
  return customTheme[type].notifMessageFontColor;
});
export var LargeNotifTextContent = styled.div.withConfig({
  componentId: "sc-16bjbgs-5"
})(["display:flex;flex-direction:column;align-self:center;"]);
export var NotifTitle = styled.div.withConfig({
  componentId: "sc-16bjbgs-6"
})(["font-size:", ";font-weight:", ";line-height:", ";color:", ";", ""], function (_ref8) {
  var customTheme = _ref8.customTheme,
      type = _ref8.type,
      bannerStyle = _ref8.bannerStyle;
  return customTheme[type][bannerStyle].notifTitleFontSize || customTheme.notifTitleFontSize;
}, function (_ref9) {
  var customTheme = _ref9.customTheme;
  return customTheme.notifTitleFontWeight;
}, function (_ref10) {
  var customTheme = _ref10.customTheme;
  return customTheme.notifTitleLineHeight;
}, function (_ref11) {
  var customTheme = _ref11.customTheme,
      type = _ref11.type;
  return customTheme.notifTitleFontColor || customTheme[type].notifTitleFontColor;
}, function (_ref12) {
  var customTheme = _ref12.customTheme,
      type = _ref12.type;
  return type === NotificationTypes.Moment ? "\n    text-shadow: ".concat(customTheme[type].notifTitleTextShadow, "\n  ") : "";
});
export var CtaLink = styled(Link).withConfig({
  componentId: "sc-16bjbgs-7"
})(["margin-left:", ";white-space:nowrap;@media only screen and (max-width:", "){margin:", " 0 0 0;}"], spacing.px8, breakpoints.md.max, spacing.px8);
export var CloseButton = styled.button.withConfig({
  componentId: "sc-16bjbgs-8"
})(["color:", ";position:absolute;top:0;right:0;background-color:transparent;border:0;margin:0;padding:0.8125rem;cursor:pointer;"], colors.grey);
export var CloseButtonContainer = styled(IconButton).withConfig({
  componentId: "sc-16bjbgs-9"
})(["position:absolute;top:0;right:0;margin:0.5rem;&:hover{background-color:", ";}"], function (_ref13) {
  var nType = _ref13.nType,
      customTheme = _ref13.customTheme;
  return customTheme[nType].hoverBackgroundCloseIconColor;
});
export var NotifIconContainer = styled.div.withConfig({
  componentId: "sc-16bjbgs-10"
})(["margin:", ";color:", ";"], function (_ref14) {
  var customTheme = _ref14.customTheme,
      type = _ref14.type,
      bannerStyle = _ref14.bannerStyle;
  return customTheme[type][bannerStyle].notifIconMargin || customTheme.notifIconMargin;
}, function (_ref15) {
  var type = _ref15.type,
      customTheme = _ref15.customTheme;
  return customTheme[type].iconColor;
});
export var SmallNotifIconContainer = styled(NotifIconContainer).withConfig({
  componentId: "sc-16bjbgs-11"
})(["& > svg{margin-top:", "rem;}"], 3 / 16);
export var MessageAndCta = styled.div.withConfig({
  componentId: "sc-16bjbgs-12"
})(["", ";text-align:", ";flex-grow:1;align-items:center;line-height:", ";align-self:flex-start;@media only screen and (max-width:", "){flex-direction:column;}", ""], function (_ref16) {
  var customTheme = _ref16.customTheme;
  return customTheme.showHorizonIcons ? "font-size: ".concat(customTheme.messageFontSize) : '';
}, function (_ref17) {
  var alignContent = _ref17.alignContent;
  return alignContent;
}, font.lineHeight.md, breakpoints.md.max, function (_ref18) {
  var customTheme = _ref18.customTheme,
      type = _ref18.type;
  return type === NotificationTypes.Moment ? "\n    text-shadow: ".concat(customTheme[type].notifMessageTextShadow, "\n  ") : "";
});
export var SmallNotificationMessageAndCta = styled(MessageAndCta).withConfig({
  componentId: "sc-16bjbgs-13"
})(["align-self:center;", ";"], function (_ref19) {
  var customTheme = _ref19.customTheme;
  return customTheme.showHorizonIcons && 'padding-right: 2px';
});
export var ButtonContainer = styled.div.withConfig({
  componentId: "sc-16bjbgs-14"
})(["padding:", ";@media only screen and (max-width:", "){padding:", " 0 0 0;}"], function (_ref20) {
  var customTheme = _ref20.customTheme,
      bannerStyle = _ref20.bannerStyle,
      type = _ref20.type;
  return bannerStyle === 'sm' || bannerStyle === 'toast' ? customTheme[type][bannerStyle].ctaButtonPadding : "".concat(spacing.px4, " ").concat(spacing.px16, " 0 ").concat(spacing.px48);
}, breakpoints.md.max, spacing.px12);
export var NotifInfoContainer = styled.div.withConfig({
  componentId: "sc-16bjbgs-15"
})(["display:flex;flex-direction:", ";@media only screen and (max-width:", "){flex-direction:column;}"], function (_ref21) {
  var customTheme = _ref21.customTheme,
      bannerStyle = _ref21.bannerStyle,
      type = _ref21.type;
  return bannerStyle === 'sm' || bannerStyle === 'toast' ? customTheme[type][bannerStyle].notifInfoFlexDirection : 'row';
}, breakpoints.md.max);
export var getThemeConfig = function getThemeConfig(themeProp) {
  return {
    "default": function _default(theme) {
      return {
        notifIconMargin: "0 ".concat(font.size.px16, " 0 0"),
        showHorizonIcons: true,
        notifTitleFontSize: theme.font.size.sm,
        notifTitleFontWeight: '700',
        messageFontSize: theme.font.size.xs,
        notifTitleLineHeight: theme.font.lineHeight.sm,
        Warning: {
          backgroundColor: theme.colors.alert.light,
          iconColor: colors.yellow700,
          notifMessageFontColor: theme.colors.secondary.darker,
          notifTitleFontColor: theme.colors.secondary.darker,
          hoverBackgroundCloseIconColor: 'transparent',
          inline: {
            borderRadius: theme.radius.md,
            width: '400px'
          },
          global: {
            borderRadius: '0',
            width: '100%'
          },
          toast: {
            borderRadius: theme.radius.md,
            width: '320px',
            boxShadow: theme.boxShadow.elevation300,
            notifInfoFlexDirection: 'column',
            ctaButtonPadding: "".concat(theme.spacing.md, " 0 0 0")
          },
          lg: {},
          sm: {}
        },
        Information: {
          backgroundColor: theme.colors.info.light,
          iconColor: theme.colors.info.dark,
          notifMessageFontColor: theme.colors.secondary.darker,
          notifTitleFontColor: theme.colors.secondary.darker,
          hoverBackgroundCloseIconColor: 'transparent',
          inline: {
            borderRadius: theme.radius.md,
            width: '400px'
          },
          global: {
            borderRadius: '0',
            width: '100%'
          },
          toast: {
            borderRadius: theme.radius.md,
            width: '320px',
            boxShadow: theme.boxShadow.elevation300,
            notifInfoFlexDirection: 'column',
            ctaButtonPadding: "".concat(theme.spacing.md, " 0 0 0")
          },
          lg: {},
          sm: {}
        },
        Success: {
          backgroundColor: theme.colors.success.light,
          iconColor: theme.colors.success.dark,
          notifMessageFontColor: theme.colors.secondary.darker,
          notifTitleFontColor: theme.colors.secondary.darker,
          hoverBackgroundCloseIconColor: 'transparent',
          inline: {
            borderRadius: theme.radius.md,
            width: '400px'
          },
          global: {
            borderRadius: '0',
            width: '100%'
          },
          toast: {
            borderRadius: theme.radius.md,
            width: '320px',
            boxShadow: theme.boxShadow.elevation300,
            notifInfoFlexDirection: 'column',
            ctaButtonPadding: "".concat(theme.spacing.md, " 0 0 0")
          },
          lg: {},
          sm: {}
        },
        Error: {
          backgroundColor: theme.colors.error.light,
          iconColor: theme.colors.error.dark,
          notifMessageFontColor: theme.colors.secondary.darker,
          notifTitleFontColor: theme.colors.secondary.darker,
          hoverBackgroundCloseIconColor: 'transparent',
          inline: {
            borderRadius: theme.radius.md,
            width: '400px'
          },
          global: {
            borderRadius: '0',
            width: '100%'
          },
          toast: {
            borderRadius: theme.radius.md,
            width: '320px',
            boxShadow: theme.boxShadow.elevation300,
            notifInfoFlexDirection: 'column',
            ctaButtonPadding: "".concat(theme.spacing.md, " 0 0 0")
          },
          lg: {},
          sm: {}
        },
        Offer: {
          backgroundColor: colors.orange050,
          iconColor: colors.orange900,
          notifMessageFontColor: theme.colors.secondary.darker,
          notifTitleFontColor: theme.colors.secondary.darker,
          hoverBackgroundCloseIconColor: 'transparent',
          inline: {},
          global: {},
          toast: {},
          lg: {
            borderRadius: theme.radius.md,
            width: '797px',
            notifTitleFontSize: theme.font.size.lg3,
            notifIconMargin: "0 ".concat(font.size.px32, " 0 0")
          },
          sm: {
            borderRadius: theme.radius.md,
            width: '312px',
            notifInfoFlexDirection: 'column',
            ctaButtonPadding: "".concat(theme.spacing.md, " 0 0 0")
          }
        },
        Guidance: {
          backgroundColor: gradient.ultraviolet,
          iconColor: theme.colors.primary.light,
          notifTitleFontColor: theme.colors.primary.light,
          notifMessageFontColor: theme.colors.primary.light,
          hoverBackgroundCloseIconColor: theme.colors.secondary.darker,
          inline: {},
          global: {},
          toast: {},
          lg: {
            borderRadius: theme.radius.md,
            width: '797px',
            notifTitleFontSize: theme.font.size.lg3,
            notifIconMargin: "0 ".concat(font.size.px32, " 0 0")
          },
          sm: {
            borderRadius: theme.radius.md,
            width: '312px',
            notifInfoFlexDirection: 'column',
            ctaButtonPadding: "".concat(theme.spacing.md, " 0 0 0")
          }
        },
        Moment: {
          backgroundColor: theme.colors.accent.dark,
          iconColor: theme.colors.primary.light,
          notifTitleFontColor: colors.manila300,
          notifTitleTextShadow: '0px 0px 13px #000000',
          notifMessageTextShadow: theme.textShadow["default"],
          notifMessageFontColor: theme.colors.primary.light,
          hoverBackgroundCloseIconColor: theme.colors.secondary.darker,
          inline: {},
          global: {},
          toast: {},
          lg: {
            borderRadius: theme.radius.md,
            width: '797px',
            notifTitleFontSize: theme.font.size.lg3,
            notifIconMargin: "0 ".concat(font.size.px32, " 0 0")
          },
          sm: {
            borderRadius: theme.radius.md,
            width: '312px',
            notifInfoFlexDirection: 'column',
            ctaButtonPadding: "".concat(theme.spacing.md, " 0 0 0")
          }
        },
        Event: {
          backgroundColor: theme.colors.secondary.lighter,
          iconColor: theme.colors.secondary.darker,
          notifTitleFontColor: colors.grey950,
          hoverBackgroundCloseIconColor: 'transparent',
          inline: {},
          global: {},
          toast: {
            borderRadius: theme.radius.md,
            width: '320px',
            boxShadow: theme.boxShadow.elevation300,
            notifInfoFlexDirection: 'column',
            ctaButtonPadding: "".concat(theme.spacing.md, " 0 0 0")
          },
          lg: {},
          sm: {}
        }
      };
    },
    fanta: {
      notifIconMargin: "0 ".concat(spacing.px12, " 0 0"),
      showHorizonIcons: false,
      notifTitleFontSize: '1.25rem',
      notifTitleFontWeight: font.weight.heavy,
      notifTitleLineHeight: font.lineHeight.md,
      notifTitleFontColor: colors.dark,
      Warning: {
        backgroundColor: colors.mustardXlight,
        iconColor: colors.mustard,
        inline: {
          borderRadius: '0',
          width: '100%',
          boxShadow: 'none'
        }
      },
      Information: {
        backgroundColor: colors.skyXlight,
        iconColor: colors.sky,
        inline: {
          borderRadius: '0',
          width: '100%',
          boxShadow: 'none'
        }
      },
      Success: {
        backgroundColor: colors.tealXlight,
        iconColor: colors.teal,
        inline: {
          borderRadius: '0',
          width: '100%',
          boxShadow: 'none'
        }
      },
      Error: {
        backgroundColor: colors.coralXlight,
        iconColor: colors.errorRed,
        inline: {
          borderRadius: '0',
          width: '100%',
          boxShadow: 'none'
        }
      }
    },
    prop: themeProp
  };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/notification-banner/dist/esm/styles.js
// module id = 1321
// module chunks = 11